import { i18n } from "services/i18nService";

import { ALL_FILTER_OPTION } from "appConstants";

export const FIELDS_TO_TRANSFORM = {
  DECIMAL_FIELDS: ["outputQuantity", "quantity", "totalQuantity"],
  MONEY_FIELDS: ["costBasis", "costPerUnit", "totalCostBasis", "variance"],
  DATE_FIELDS: [],
  DATETIME_FIELDS: ["txnDate"],
  NON_UTC_DATETIME_FIELDS: [],
};

export function getColumnConfig(currencyCode) {
  const toNumber = (v) => v?.toNumber() ?? "";
  return [
    { heading: i18n("columns.TxnQty"), name: "quantity", downloadFn: toNumber },
    { heading: i18n("columns.TotalQty"), name: "totalQuantity", downloadFn: toNumber },
    { heading: `${i18n("columns.CostBasis")} (${currencyCode})`, name: "costBasis", downloadFn: toNumber },
    { heading: `${i18n("columns.Variance")} (${currencyCode})`, name: "variance", downloadFn: toNumber },
    { heading: `${i18n("columns.TotalCostBasis")} (${currencyCode})`, name: "totalCostBasis", downloadFn: toNumber },
    { heading: `${i18n("columns.AvgValue")} (${currencyCode})`, name: "costPerUnit", downloadFn: toNumber },
    { heading: `${i18n("columns.TxnCostPerUnit")} (${currencyCode})`, name: "txnCostPerUnit", downloadFn: toNumber },
  ];
}

export const TYPE_FILTER_OPTIONS = [
  ALL_FILTER_OPTION,
  { id: 1, name: "shipment" },
  { id: 2, name: "return to vendor" },
  { id: 3, name: "item receipt" },
  { id: 4, name: "return" },
  { id: 5, name: "inventory adjustment" },
  { id: 6, name: "transfer" },
  { id: 7, name: "build" },
  { id: 8, name: "process transaction" },
];
